import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Plus, Trash2, Save } from "lucide-react";

const CATEGORIES = [
  { key: "festival", label: "Festival" },
  { key: "konser",   label: "Konser" },
  { key: "kultur",   label: "Kültür" },
  { key: "maraton",  label: "Spor" },
  { key: "sergi",    label: "Sergi" },
  { key: "balon",    label: "Balon" },
];

export default function AdminEventsPage() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = async () => { const { data } = await api.get("/admin/events"); setItems(data || []); };
  useEffect(() => { load(); }, []);

  const startNew = () => setEditing({ slug: "", title: "", description: "", starts_on: "", ends_on: "", location: "", category: "festival", image_url: "", is_published: true });
  const save = async () => {
    try {
      if (editing.id) await api.put(`/admin/events/${editing.id}`, editing);
      else await api.post("/admin/events", editing);
      setEditing(null); load();
    } catch (e) { alert(e.response?.data?.detail || e.message); }
  };
  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/admin/events/${id}`); load(); };

  return (
    <div data-testid="admin-events">
      <div className="flex items-center justify-between mb-8">
        <div><h1 className="font-serif text-4xl text-cc-text mb-2">Kapadokya Takvimi</h1>
        <p className="text-sm text-cc-muted">Festival, konser, kültür ve etkinlikler</p></div>
        <button onClick={startNew} className="cc-btn" data-testid="new-event-btn"><Plus size={14} /> Yeni Etkinlik</button>
      </div>

      {editing && (
        <div className="bg-white border border-admin-border p-6 mb-8" data-testid="event-editor">
          <div className="grid md:grid-cols-2 gap-4 mb-4">
            <label className="text-xs text-cc-muted">Slug <input value={editing.slug} onChange={(e) => setEditing({ ...editing, slug: e.target.value })} className="cc-input" /></label>
            <label className="text-xs text-cc-muted">Başlık <input value={editing.title} onChange={(e) => setEditing({ ...editing, title: e.target.value })} className="cc-input" /></label>
          </div>
          <label className="text-xs text-cc-muted block mb-4">Açıklama
            <textarea value={editing.description} onChange={(e) => setEditing({ ...editing, description: e.target.value })} className="cc-input min-h-[80px]" /></label>
          <div className="grid md:grid-cols-4 gap-4 mb-4">
            <label className="text-xs text-cc-muted">Başlangıç <input type="date" value={editing.starts_on || ""} onChange={(e) => setEditing({ ...editing, starts_on: e.target.value })} className="cc-input" /></label>
            <label className="text-xs text-cc-muted">Bitiş (opt.) <input type="date" value={editing.ends_on || ""} onChange={(e) => setEditing({ ...editing, ends_on: e.target.value })} className="cc-input" /></label>
            <label className="text-xs text-cc-muted">Konum <input value={editing.location || ""} onChange={(e) => setEditing({ ...editing, location: e.target.value })} className="cc-input" /></label>
            <label className="text-xs text-cc-muted">Kategori
              <select value={editing.category} onChange={(e) => setEditing({ ...editing, category: e.target.value })} className="cc-input">
                {CATEGORIES.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
              </select>
            </label>
          </div>
          <label className="text-xs text-cc-muted block mb-4">Görsel URL
            <input value={editing.image_url || ""} onChange={(e) => setEditing({ ...editing, image_url: e.target.value })} className="cc-input" /></label>
          <div className="flex gap-3">
            <button onClick={save} className="cc-btn text-[10px] py-2"><Save size={14} /> Kaydet</button>
            <button onClick={() => setEditing(null)} className="cc-btn cc-btn-ghost text-[10px] py-2">İptal</button>
          </div>
        </div>
      )}

      <div className="bg-white border border-admin-border">
        <table className="w-full text-sm">
          <thead className="bg-admin-bg/60 text-left">
            <tr>
              <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Tarih</th>
              <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Etkinlik</th>
              <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Kategori</th>
              <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Konum</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((ev) => (
              <tr key={ev.id} className="border-t border-admin-border">
                <td className="px-4 py-3 font-mono text-xs">{ev.starts_on}</td>
                <td className="px-4 py-3">{ev.title}</td>
                <td className="px-4 py-3 text-cc-muted">{ev.category}</td>
                <td className="px-4 py-3 text-cc-muted">{ev.location}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => setEditing(ev)} className="text-cc-muted hover:text-cc-sepia mr-3 text-xs">Düzenle</button>
                  <button onClick={() => del(ev.id)} className="text-cc-muted hover:text-red-600"><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
